import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'components/_basic/Button/Button';

import { IViewPaymentHistoryButtonProps } from './types';

export const ViewPaymentHistoryButton: React.FC<IViewPaymentHistoryButtonProps> = ({ paymentHistory }) => {
  const { t } = useTranslation();
  if (!paymentHistory.receipt) {
    return null;
  }

  const handleViewReceipt = () => {
    if (paymentHistory.receipt) {
      window.open(paymentHistory.receipt, '_blank');
    }
  };

  return (
    <Button size="small" sx={{ padding: 0 }} onClick={handleViewReceipt}>
      {t('view')}
    </Button>
  );
};
